import React from "react";
import "./Future.css";
import futureimage from "../assetsprogressive/futureimage.png";

export default function HeroSection() {
  return (
    <div className="progressive-wrapper">
   <div id="progressive-future">
       <div id="heroprogressive">
        <div className="main-container">
          <div className="left">
            <h1 className="h1-tag">PWAs Optimized for Speed, Reach, and Stability</h1>
            <p>Our PWA solutions are built for teams that want speed, stability, and engagement without technical headaches. Everything is optimized for performance, retention, and long-term scalability.</p>
          </div>
          <div className="right">
            <img src={futureimage} alt="error" />
          </div>
        </div>
      </div>
   </div>
    </div>
  );
}
